import {
  FETCH_DESIGNATION_BASED_REQUEST,
  FETCH_DESIGNATION_BASED_SUCCESS,
  FETCH_DESIGNATION_BASED_FAILURE,
} from "../constants/DesignationbasedConstants";

import DesignationBasedService from "../service/DesignationBasedService";

export const fetchDesignationBased = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DESIGNATION_BASED_REQUEST });

    
    const data = await DesignationBasedService.getAll(date);

    dispatch({
      type: FETCH_DESIGNATION_BASED_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_DESIGNATION_BASED_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

